import { People as PeopleIcon } from '@mui/icons-material';
import { TabList, TabPanel } from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  styled,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { LocationOverrideChip } from 'src/features/locations/scheduleLocationPageOO/modules/OOLocationSchedulePageTable/OOLocationSchedulePageTable.styled';

export const FixedWidthColumn = styled(Box)(
  ({ theme }) => `
  width: 400px;
  height: 100vh;
  background:${theme.palette.primary.lightest};
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 24px 0 24px;
  overflow-y: auto;
`,
);

export const StyledPointerText = styled(Typography)`
  cursor: pointer;
`;

export const StyledTabs = styled(Tabs)(
  ({ theme }) => `
   border: ${theme.palette.brand.borderGrey};
  display: flex;
`,
);

export const StyledTabItem = styled(Tab)(
  ({ theme }) => `
   background: ${theme.palette.primary.main};
   color: white;
   width: 50%;
`,
);

export const StyledAccordion = styled(Accordion)(
  ({ theme }) => `
  border: 1px solid ${theme.palette.brand.ash};
  border-radius: 8px;
  background-color:${theme.palette.grey[50]};
  margin-bottom: 24px;
  margin-top:0;

  &:first-of-type {
    border-radius: 8px;
  }
  
  &:last-of-type {
    margin-top: 0;
  }

  .MuiAccordion-root & {
    border: 1px solid ${theme.palette.brand.ash};
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-left: none;
    border-right: none;
    margin-bottom: 0;
  }
`,
);

export const StyledAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.brand.ash};
  padding-left:16px;
   padding-right:16px;
  overflow: visible;
`,
);

export const VerticalSpacedContainer = styled(Grid)`
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
`;

export const StyledGrid = styled(Grid)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.brand.ash};
  padding: 16px 16px 16px 40px;
  margin-left: -16px;
  width: calc(100% + 32px); 
`,
);

export const StyledLocationOverrideChip = styled(LocationOverrideChip)`
  height: 22px;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  flex-direction: row-reverse;

  & .MuiAccordionSummary-content {
    margin-left: 8px;
  }

  /* Style ONLY when nested inside another Accordion */
  .MuiAccordion-root .MuiAccordion-root & {
    margin-left: 28px;
  }
`;

export const CustomTabPanel = styled(TabPanel)`
  padding: 0;

  &.MuiTabPanel-root {
    margin-top: 16px;
  }
`;

export const ContentPanel = styled(Stack)`
  display: flex;
`;

export const StyledPeopleIcon = styled(PeopleIcon)(
  ({ theme }) => `
  margin-right: 4px;
  color: ${theme.palette.grey[600]};
`,
);
export const CustomTab = styled(Tab)(
  ({ theme }) => `
  &.Mui-selected {
    color: white;
    background-color: ${theme.palette.primary.main};
    font-weight: 500;
  }

  width: 50%;
  height: 36px;
  min-height: 36px;
  padding: 0;
  color: ${theme.palette.primary.main};
  font-size: 15px;
  line-height:1.73;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
`,
);

export const CustomTabList = styled(TabList)(
  ({ theme }) => `
  border: 1px solid ${theme.palette.primary.main};
  border-radius: 4px;
  min-height: auto;
  display: flex;
  margin-top: 20px;

  & .MuiTabs-indicator {
    display: none;
  }
`,
);

export const StyledLink = styled(Link)(
  ({ theme }) => `
  color: ${theme.palette.primary.main};
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 2px;

  .MuiAccordion-root .MuiAccordion-root & {
      margin-left: 60px;
      display: block;
    }
  `,
);

export const LightBlueLink = styled(Box)(
  ({ theme }) => `
  border: 1px solid ${theme.palette.brand.ash};
  border-radius: 8px;
  padding: 16px;
  background-color:${theme.palette.grey[50]};
`,
);

export const Header = styled(Box)(
  ({ theme, $isDefaultAssembly }) => `
    border-bottom: 1px solid ${theme.palette.brand.ash};
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 14px;
    position: relative;

    &:before {
      content: "";
      width: 4px;
      height: 34px;
      background-color: ${
        $isDefaultAssembly
          ? theme.palette.brand.charcoal
          : theme.palette.primary.main
      };
      border-radius: 8px;
      position: absolute;
      top: 7%;
      left: 0;
     
    }
  `,
);

export const NoBackupImage = styled('img')`
  width: 200px;
  height: 161px;
`;

export const HeaderText = styled(Typography)`
  font-size: 20px;
  line-height: 1.3;
  font-weight: 500;
  margin-left: 12px;
`;

export const EmptyStateWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top:16px;
  border:1px solid  ${theme.palette.brand.borderGrey};
  border-radius:8px;
  padding: 20px;
  background-color: ${theme.palette.grey[50]};
  `,
);

export const BottomPanel = styled(Stack)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: auto;
  margin-bottom: 24px;
`;
export const ViewContentButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'flex',
})<{ flex?: number }>(
  ({ theme, flex = 1 }) => `
  display: flex;
  align-items: center;
  background-color: ${theme.palette.primary.main};
  height: 36px;
  color: white;
  border-radius: 4px;
  justify-content: center;
  font-size: 13px;
  line-height: 1.69;
  flex: ${flex};
   // TODO: Remove 'display: none' in future slices
  display: none;
`,
);

export const DeleteScheduleItemButton = styled(IconButton)`
  padding: 0;
  margin-left: auto;
`;

export const DeleteIconButton = styled(Button)(({ theme }) => ({
  flex: 2,
  height: 36,
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  borderRadius: 4,
  padding: 6,
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabled,
    color: theme.palette.action.disabled,
  },
}));

export const EditIconButton = styled(IconButton)<{ disabled?: boolean }>(
  ({ theme, disabled }) => `
    height: 36px;
    border: 1px solid ${
      disabled ? theme.palette.text.disabled : theme.palette.primary.main
    };
    color: ${theme.palette.primary.main};
    border-radius: 4px;
    padding: 6px;
  `,
);

export const ViewCalendarContentButton = styled(Button)(
  ({ theme }) => `
  flex: 2;
  height: 36px;
  border: 1px solid ${theme.palette.action.disabled};
  color: white;
  border-radius: 4px;
  padding: 6px;
`,
);

export const OverrideIconButton = styled(Button)`
  flex: 1;
  height: 36px;
  border-radius: 4px;
  padding: 6px;
  font-size: 14px;
  gap: 6px;
`;

export const PreviewButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'flex',
})<{ flex?: number; disabled?: boolean }>(
  ({ theme, flex = 0, disabled }) => `
    flex: ${flex};
    height: 36px;
    border-radius: 4px;
    padding: 6px 16px;
    text-transform: none;
    background-color: ${
      disabled
        ? theme.palette.action.disabledBackground
        : theme.palette.primary.main
    };
    color: ${
      disabled
        ? theme.palette.text.disabled
        : theme.palette.primary.contrastText
    };
    &:hover {
      background-color: ${
        disabled
          ? theme.palette.action.disabledBackground
          : theme.palette.primary.dark
      };
    }
`,
);
